export const scrollToTop = () => {
	window.scrollTo(0, 0);
	document.querySelector('#react-app')?.scrollTo(0, 0);
};
